export default __webpack_public_path__ + "assets/dj.98f6e262.svg";